import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpService } from 'src/app/shared/services/http.service';
import { SubmitAuthService } from 'src/app/shared/services/submit-auth.service';
import { UserService } from 'src/app/shared/services/user.service';

@Injectable({
  providedIn: 'root',
})
export class CustomerAuthService {
  private loggedIn = false;
  private OkOtp = false;
  private jwtLoggedInSubject = new BehaviorSubject<boolean>(false);
  loggedIn$ = this.jwtLoggedInSubject.asObservable();
  constructor(
    private httpService: HttpService,
    private submitAuthService:SubmitAuthService,
    private userService :UserService,
  ) { }

  isLoggedIn(): boolean {
    if (localStorage.getItem('jwtToken')) {
      return true;
    }
    return this.loggedIn;
  }

  isOkOtp(): boolean {
    return this.OkOtp;
  }

  setUserLoggedIn(value: boolean): void {
    this.loggedIn = value;
    this.setCanSubmit(value);
    this.userService?.setJWtCustomerLogin(value);
  }

  setCanSubmit(value: boolean): void {
    this.submitAuthService.setCanSubmit(value);
  }

  setOkOtp(value: boolean): void {
    this.OkOtp = value;
  }

  sendOTP(email: string): Observable<any> {
    return this.httpService.jwtPost('sendotp', JSON.stringify(email), {
      headers: new HttpHeaders({
        'Content-Type': 'application/json; charset=utf-8',
      }),
    });
  }

  validateOtp(body:any): Observable<any> {
    return this.httpService.jwtPost('verifyotp', body);
  }

  logout(): void {
    this.loggedIn = false;
  }

  setJwtLoggedInSubject(value: boolean){
    this.jwtLoggedInSubject.next(value);
  }
  getJwtLoggedInSubject(): Observable<boolean> {
    return this.loggedIn$;
  }
}
